import { Dialog, Toast } from 'vant'
import { MessageBox } from 'element-ui'
import store from '@/store'

export default {
  install (Vue) {
    Vue.prototype.confirm = function (message) {
      return new Promise((resolve, reject) => {
        if (store.getters.isPC) {
          MessageBox.confirm(message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(action => {
            resolve(action)
          }).catch(e => {
            reject(e)
          })
        } else {
          Dialog.confirm({
            title: '提示',
            message: message
          }).then(action => {
            resolve(action)
          }).catch(e => {
            reject(e)
          })
        }
      })
    }
    /* eslint-disable */
    Vue.prototype.message = function (msg, t) {
      return new Promise((resolve) => {
        if (store.getters.isPC) {
          this.$message({
            message: msg,
            customClass: t ? 'custom-message' : 'a',
            type: t ? t : 'error'
          })
        } else {
          Toast({
            message: msg
          })
        }
      })
    }
    /* eslint-enable */
    Vue.prototype.showLoading = function (message = '加载中...') {
      Toast.loading({
        message,
        forbidClick: true,
        loadingType: 'spinner'
      })
    }
    Vue.prototype.hideLoading = function () {
      Toast.clear()
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/messageBox.js